/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Describe writable team fields without read-only response fields in the API client.
 * @export
 * @interface TeamWrite
 */
export interface TeamWrite {
    /**
     *
     * @type {string}
     * @memberof TeamWrite
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof TeamWrite
     */
    slug?: string;
}

/**
 * Check if a given object implements the TeamWrite interface.
 */
export function instanceOfTeamWrite(value: object): value is TeamWrite {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TeamWriteFromJSON(json: any): TeamWrite {
    return TeamWriteFromJSONTyped(json, false);
}

export function TeamWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamWrite {
    if (json == null) {
        return json;
    }
    return {

        'name': json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
    };
}

  export function TeamWriteToJSON(json: any): TeamWrite {
      return TeamWriteToJSONTyped(json, false);
  }

  export function TeamWriteToJSONTyped(value?: TeamWrite | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'name': value['name'],
        'slug': value['slug'],
    };
}
